import { ClassSummary } from './ClassSummary';
export default ClassSummary;
